import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove, makeInvoice } from '../../services/invoice'

function* fetchInvoicesRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchInvoices'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_INVOICE,
    result,
  })
}

function* fetchInvoices({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = null // JSON.parse(localStorage.getItem('fetchInvoices'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = size || localStorage.getItem('pageSize') || 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchInvoices', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_INVOICE,
    result,
  })
}

function* fetchInvoiceEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_INVOICE,
    result,
  })
}

function* fetchInvoiceSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const saveResult = yield call(save, values)
  if (saveResult !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  const result = yield call(find, saveResult)
  yield put({
    type: actions.EDIT_INVOICE,
    result,
  })
}

function* fetchInvoiceDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_INVOICE_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_INVOICES,
  })
}

// function* createInvoice({ workOrderStatus, location, area, address, begin, end, excel }) {
//   yield put({
//     type: actions.REQUESTING,
//   })
//   const result = yield call(create, workOrderStatus, location, area, address, begin, end, excel)
//   yield put({
//     type: actions.CREATE_INVOICE_RECIEVED,
//     result,
//   })
// }
 
function* resetInvoice() {
  yield put({
    type: actions.RESET_INVOICE_RECIEVED,
  })
}

function* createInvoiceReset() {
  yield put({
    type: actions.CREATE_RESET_INVOICE_RECIEVED,
  })
}

function* refreshCall() {
  yield put({
    type: actions.Refresh_Recieved,
  })
}

function* refreshReset() {
  yield put({
    type: actions.Refresh_reset_Recieved,
  })
}

function* makeInvoice2() {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(makeInvoice);
  yield put({
    type: actions.MAKE_NEW_INVOICE_RECIEVED,
    payload: result,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.Refresh_reset, refreshReset),
    takeEvery(actions.Refresh, refreshCall),

    takeEvery(actions.RESET_INVOICE, resetInvoice),
    takeEvery(actions.MAKE_NEW_INVOICE, makeInvoice2),
    takeEvery(actions.CREATE_RESET_INVOICE, createInvoiceReset),

    // takeEvery(actions.CREATE_INVOICE, createInvoice),


    takeEvery(actions.FETCH_INVOICES, fetchInvoices),
    takeEvery(actions.FETCH_INVOICE, fetchInvoiceEdit),
    takeEvery(actions.SAVE_INVOICE, fetchInvoiceSave),
    takeEvery(actions.DELETE_INVOICE, fetchInvoiceDelete),
    takeEvery(actions.RE_FETCH_INVOICES, fetchInvoicesRefresh),
  ])
}
